export default {
  danger: 'danger',
  default: 'default',
  success: 'success'
};